import { useEffect, useMemo, useRef } from "react";
import ReactFlow, {
  ReactFlowProvider,
  useNodesState,
  useEdgesState,
  Background,
} from "reactflow";
import { useSelector } from "react-redux";
import "reactflow/dist/style.css";
import "./flowStyle.css";

const OverviewFlow = () => {
  const waterAuthority = useSelector((state) => state.waterAuthority.data);
  const flowSystem = waterAuthority?.attributes?.diagramSchema;
  const initialNodes = useMemo(() => flowSystem?.nodes ?? [], [flowSystem]);
  const initialEdges = useMemo(() => flowSystem?.edges ?? [], [flowSystem]);

  const reactFlowWrapper = useRef(null);
  const [nodes, setNodes] = useNodesState(initialNodes);
  const [edges, setEdges] = useEdgesState(initialEdges);

  useEffect(() => {
    setNodes(initialNodes);
    setEdges(initialEdges);
  }, [waterAuthority, setNodes, setEdges, initialEdges, initialNodes]);

  return (
    <div className="dndflow overviewFlow">
      <ReactFlowProvider>
        <div className="reactflow-wrapper" ref={reactFlowWrapper}>
          <ReactFlow
            nodes={nodes}
            edges={edges}
            nodesDraggable={false}
            zoomOnDoubleClick={false}
            zoomOnScroll={false}
            onConnect={() => {}}
            onDragOver={() => {}}
            onDrop={() => {}}
            fitView
          >
            {/* <Controls /> */}
            <Background variant="dots" gap={12} size={1} />
          </ReactFlow>
        </div>
      </ReactFlowProvider>
    </div>
  );
};

export default OverviewFlow;
